import FilesDashboard from "../pages/Admin/FilesDashboard";
import SectorsPage from "../pages/Admin/Sectors/SectorsPage";
import AgentsDashboard from "../pages/Agents/AgentsDashboard";
import CompanyDashboard from "../pages/Agents/CompanyDashboard/CompanyDashboard";
import Archive from "../pages/Archive/Archive";
import Search from "../pages/Archive/Search";
import BugReport from "../pages/BugReport/BugReport";
import ContactForm from "../pages/ContactPage/ContactForm";
import Activities from "../pages/Dashboard/Activities/Activities";
import AddComplaint from "../pages/Dashboard/Complaint/AddComplaint/AddComplaint";
import ComplaintDetails from "../pages/Dashboard/Complaint/ComplaintDetails/ComplaintDetails";
import ComplaintsDashboard from "../pages/Dashboard/Complaint/ComplaintsDashboard";
import ContactMessages from "../pages/Dashboard/Contacts/ContactMesages";
import Emails from "../pages/Dashboard/Emails/Emails";
import ProfileComponent from "../pages/Dashboard/UpdateProfile/ProfileComponent";
import BarChart from "../pages/Graph/BarChart";
import GraphDashboard from "../pages/Graph/GraphDashboard";
import Timeline from "../pages/Graph/Timeline";
import { Timeline2 } from "../pages/Graph/Timeline2";
import HelpPage from "../pages/HelpPage/HelpPage";
import Test from "../pages/Test/Test";
import DefaultLayout from "./DefaultLayout/DefaultLayout";

export default [
  {
    path: "/dashboard/main",
    layout: DefaultLayout,
    component: ComplaintsDashboard,
  },
  {
    path: "/dashboard/archive",
    layout: DefaultLayout,
    component: Archive,
  },
  {
    path: "/dashboard/contactMessages",
    layout: DefaultLayout,
    component: ContactMessages,
  },
  {
    path: "/dashboard/search",
    layout: DefaultLayout,
    component: Search,
  },
  {
    path: "/dashboard/emails",
    layout: DefaultLayout,
    component: Emails,
  },
  {
    path: "/dashboard/activities",
    layout: DefaultLayout,
    component: Activities,
  },
  {
    path: "/dashboard/contact",
    layout: DefaultLayout,
    component: ContactForm,
  },
  {
    path: "/dashboard/help",
    layout: DefaultLayout,
    component: HelpPage,
  },
  {
    path: "/dashboard/reports",
    layout: DefaultLayout,
    component: GraphDashboard,
  },
  {
    path: "/dashboard/sectors",
    layout: DefaultLayout,
    component: SectorsPage,
  },
  {
    path: "/dashboard/agents",
    layout: DefaultLayout,
    component: AgentsDashboard,
  },
  {
    path: "/dashboard/companies",
    layout: DefaultLayout,
    component: CompanyDashboard,
  },
  {
    path: "/dashboard/bugReport",
    layout: DefaultLayout,
    component: BugReport,
  },
  {
    path: "/dashboard/test",
    layout: DefaultLayout,
    component: Test,
  },
  {
    path: "/files",
    layout: DefaultLayout,
    component: FilesDashboard,
  },

  {
    path: "/dashboard/complaintDetails/:id",
    layout: DefaultLayout,
    component: ComplaintDetails,
  },
  {
    path: "/dashboard/profile",
    layout: DefaultLayout,
    component: ProfileComponent,
  },
  {
    path: ["/dashboard/createComplaint", "/dashboard/manage/:id"],
    layout: DefaultLayout,
    component: AddComplaint,
  },
];
